















import { defineComponent } from '@vue/composition-api';
import { BaseParagraph, ParagraphSize } from '../base-paragraph';

export default defineComponent({
  name: 'BaseInformationItem',
  components: { BaseParagraph },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  setup() {
    return { ParagraphSize };
  },
});
